// //LOCAL
// export const BASE_URL = 'http://localhost:4500';
// export const FACEBOOK_APP_ID: any = '152110156924040';
// export const GOOGLE_APP_ID: any =
//   '679675228906-53q8tu0dclkmjkagp9d31r882v7rk3ih.apps.googleusercontent.com';
// export const PAYMENT_GATEWAY_KEY = 'rzp_test_hq5cJ2vuVoC95G';
// export const BASE_URL_WEB = "http://localhost:3002";
// export const BASE_URL_UI = "http://localhost:3000";
// export const CLIENT_ID = '1002804755016062';
// export const PROCUREMENT_URL_CLANCONNECT = 'http://localhost:3000/?sessionId=AOL0fDkdO5UMWntauHEk';
// export const PROCUREMENT_URL_VALUE360 = 'http://localhost:3000/?sessionId=kpDWfjOl59ubcysYvY9q';
// export const PROCUREMENT_URL_POPKORN = 'http://localhost:3000/?sessionId=ORhOnSm5uVbsbMCdORjj';
// export const CLIENT_URL_CLANCONNECT = 'http://localhost:3000/?sessionId=AOL0fDkdO5UMWntauHEk';
// export const CLIENT_URL_VALUE360 = 'http://localhost:3000/?sessionId=kpDWfjOl59ubcysYvY9q';
// export const CLIENT_URL_POPKORN = 'http://localhost:3000/?sessionId=ORhOnSm5uVbsbMCdORjj';
// export const VENDOR_URL_CLANCONNECT = 'http://localhost:3000/?sessionId=A7k9X2pQ4mT8zL1bC6sR';
// export const VENDOR_URL_VALUE360 = 'http://localhost:3000/?sessionId=9DfK3vTq1Zx7mB8HcP2L';
// export const VENDOR_URL_POPKORN = 'http://localhost:3000/?sessionId=W4nQ8sK2yR5Tz1mJ7bXp';
// Stage
export const BASE_URL = 'https://ccapi.irida.in';
export const FACEBOOK_APP_ID: any = '152110156924040';
export const GOOGLE_APP_ID: any =
  '679675228906-53q8tu0dclkmjkagp9d31r882v7rk3ih.apps.googleusercontent.com';
export const PAYMENT_GATEWAY_KEY = 'rzp_test_hq5cJ2vuVoC95G';
export const BASE_URL_WEB = "https://webstage.irida.in";
export const BASE_URL_UI = "https://stage.irida.in";
export const CLIENT_ID = '1002804755016062';
export const PROCUREMENT_URL_CLANCONNECT = 'https://webstage.irida.in/?sessionId=AOL0fDkdO5UMWntauHEk';
export const PROCUREMENT_URL_VALUE360 = 'https://webstage.irida.in/?sessionId=kpDWfjOl59ubcysYvY9q';
export const PROCUREMENT_URL_POPKORN = 'https://webstage.irida.in/?sessionId=ORhOnSm5uVbsbMCdORjj';
export const CLIENT_URL_CLANCONNECT = 'https://webstage.irida.in/?sessionId=AOL0fDkdO5UMWntauHEk';
export const CLIENT_URL_VALUE360 = 'https://webstage.irida.in/?sessionId=kpDWfjOl59ubcysYvY9q';
export const CLIENT_URL_POPKORN = 'https://webstage.irida.in/?sessionId=ORhOnSm5uVbsbMCdORjj';
export const VENDOR_URL_CLANCONNECT = 'https://webstage.irida.in/?sessionId=A7k9X2pQ4mT8zL1bC6sR';
export const VENDOR_URL_VALUE360 = 'https://webstage.irida.in/?sessionId=9DfK3vTq1Zx7mB8HcP2L';
export const VENDOR_URL_POPKORN = 'https://webstage.irida.in/?sessionId=W4nQ8sK2yR5Tz1mJ7bXp';
// LIVE
// export const BASE_URL = 'https://api.clanconnect.ai';
// export const FACEBOOK_APP_ID: any = '586539722116753';
// export const GOOGLE_APP_ID: any =
//   '516197375270-5quads0lluld13ht2bdb3euto2qk6a64.apps.googleusercontent.com';
// export const PAYMENT_GATEWAY_KEY = 'rzp_live_OtRn3lHK9qOh7I';
// export const BASE_URL_WEB = "https://www.clanconnect.ai";
// export const BASE_URL_UI = "https://app.clanconnect.ai";
// export const CLIENT_ID = '1103424734849222';
// export const PROCUREMENT_URL_CLANCONNECT = 'https://procurement.clanconnect.ai/?sessionId=AOL0fDkdO5UMWntauHEk';
// export const PROCUREMENT_URL_VALUE360 = 'https://procurement.value360india.com/?sessionId=kpDWfjOl59ubcysYvY9q';
// export const PROCUREMENT_URL_POPKORN = 'https://procurement.thepopkorn.com/?sessionId=ORhOnSm5uVbsbMCdORjj';
// export const CLIENT_URL_CLANCONNECT = 'https://client.clanconnect.ai/?sessionId=AOL0fDkdO5UMWntauHEk';
// export const CLIENT_URL_VALUE360 = 'https://client.value360india.com/?sessionId=kpDWfjOl59ubcysYvY9q';
// export const CLIENT_URL_POPKORN = 'https://client.thepopkorn.com/?sessionId=ORhOnSm5uVbsbMCdORjj';
// export const VENDOR_URL_CLANCONNECT = 'https://vendor.clanconnect.ai/?sessionId=A7k9X2pQ4mT8zL1bC6sR';
// export const VENDOR_URL_VALUE360 = 'https://vendor.value360india.com/?sessionId=9DfK3vTq1Zx7mB8HcP2L';
// export const VENDOR_URL_POPKORN = 'https://vendor.thepopkorn.com/?sessionId=W4nQ8sK2yR5Tz1mJ7bXp';
/* 
//local Base URL
export const FACEBOOK_APP_ID: any = '152110156924040'; //local facebook_app id
export const FACEBOOK_APP_ID: any = "586539722116753";
export const GOOGLE_APP_ID: any =
'516197375270-5quads0lluld13ht2bdb3euto2qk6a64.apps.googleusercontent.com';
"846728021163-umtm4qsds67q9disf83pmejgdijon24l.apps.googleusercontent.com";

*/


export const CAPTCHA_SITE_KEY = '6LelK2wnAAAAAKVBlc3DYgKUGcYbOfgWFp-bdITU';

//SM api base url
export const SM_API_BASE_URL = 'https://smapi.clanconnect.ai';
//

//default Images
export const DefaultAccountLogo = {
brand:
  'https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/brand_default.jpg',
agency:
  'https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/agency_default.jpg',
influencer:
  'https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/influencer_default.jpg',
talent_partner:
  'https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/talent_partner_default.jpg',
};

export const DefaultUserProfile = {
influencer_male_default:
  'https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/influencer_male_default.png',
influencer_female_default:
  'https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/influencer_female_default.png',
influencer_unknown_default:
  'https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/influencer_unknown_default.jpg',
};

export const DummyCampaignImage = {
default_campaign_image:
  'https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/dummy_campaign.jpg',
  brand_default_image: 
  "https://gt-clanconnect.s3.ap-south-1.amazonaws.com/default/brand_default.jpg"
};



export const CHATINTERVAL = (1000 * 5) // In Seconds

export const GSTIN_TOKEN = 'UISDGFIUAYDGFIUDYIUASDGFI';

export const FORCE_US_INFLUENCER_MENU = false;